import { INewOrder, IProductOptionsDTO } from "@/interface"
import { AvailableOption } from "@/models/products/option-by-product"

export class OptionsByProduct {
    public id: number;
    public product: string;
    public optionsData: AvailableOption[] | null;
    public optionsOther: AvailableOption[] | null;

    constructor(base?: Partial<OptionsByProduct>){
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IProductOptionsDTO) {
        if (!dto) {return null;}
        return new OptionsByProduct({
            id: dto.product_id,
            product: dto.product,
            optionsData: dto.available_options ?
                dto.available_options.filter(options => options.data).map(option => AvailableOption.fromDto(option)).sort((a, b) => b.data.limit_amount - a.data.limit_amount) : null,
            optionsOther: dto.available_options ? dto.available_options.filter(options => !options.data).map(option => AvailableOption.fromDto(option)).sort((a, b) => b.price - a.price) : null
        });
    }

    static initOptionByProduct() {
        return new OptionsByProduct({
            id: 0,
            product: '',
            optionsData: null,
            optionsOther: null
        })
    }

    static fromINewOrder(value: INewOrder) {
        return new OptionsByProduct({
            id: value.id,
            product: value.product,
            optionsData: value.optionsData,
            optionsOther: value.optionsOther
        })
    }
}